import PropTypes from 'prop-types';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';
import { useTranslation } from '../../../common/LocalizationProvider';
import ButtonUpgradePro from '../../ButtonUpgradePro';
import { selectAbonnementData } from '../../../createSelectorUtils';

// ----------------------------------------------------------------------

AppReportGraph.propTypes = {
  summary: PropTypes.array
};

export default function AppReportGraph({ summary }) {
  const t = useTranslation();
  const abonnement = useSelector(selectAbonnementData);

  const CHART_DATA = [
    {
      name: t('DB_SpeedAlert'),
      data: [
        summary.reduce((sum, item) => {
          sum += item.alertSpeedAtterrisssage;
          return sum;
        }, 0),
        summary.reduce((sum, item) => {
          sum += item.alertSpeedDecollage;
          return sum;
        }, 0),
        summary.reduce((sum, item) => {
          sum += item.alertSpeedVol;
          return sum;
        }, 0),
        summary.reduce((sum, item) => {
          sum += item.alertSpeedRoulage;
          return sum;
        }, 0)
      ]
    },
    {
      name: t('DB_GAlert'),
      data: [
        summary.reduce((sum, item) => {
          sum += item.alertgAtterrisssage;
          return sum;
        }, 0),
        0,
        summary.reduce((sum, item) => {
          sum += item.alertgVol;
          return sum;
        }, 0),
        summary.reduce((sum, item) => {
          sum += item.alertgRoulage;
          return sum;
        }, 0)
      ]
    },
    {
      name: t('DB_RestrictedZone'),
      data: [
        0,
        0,
        summary.reduce((sum, item) => {
          sum += item.alertGeofence;
          return sum;
        }, 0),
        0
      ]
    }
  ];

  const CHART_DATA_EXAMPLE = [
    {
      name: t('DB_SpeedAlert'),
      data: [10, 10, 10, 10]
    },
    {
      name: t('DB_GAlert'),
      data: [10, 10, 10]
    },
    {
      name: t('DB_RestrictedZone'),
      data: [10, 10, 10, 10]
    }
  ];

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      stacked: true
    },
    plotOptions: { bar: { columnWidth: '11%', borderRadius: 4 } },
    fill: { type: ['solid', 'gradient', 'solid'] },
    xaxis: {
      categories: [t('DB_Landing_S'), t('DB_TakeOff_S'), t('DB_Flight_S'), t('DB_Taxiing_S')]
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        show: true
      },
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return y.toFixed(0);
          }
          return y;
        }
      }
    }
  });

  return (
    <Card>
      <CardHeader title={t('DB_Statistics')} />
      <Box sx={{ p: 3, pb: 1, filter: abonnement ? 'none' : 'blur(5px)' }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={abonnement ? CHART_DATA : CHART_DATA_EXAMPLE}
          options={chartOptions}
          height={382}
        />
      </Box>
      {!abonnement && <ButtonUpgradePro />}
    </Card>
  );
}
